import http from '@core/fetch'
import { getRequestUrl } from '@util'
export default {
  getCityList: () => {
    return http(
      getRequestUrl(
        '/hms/hljActivity/appApi/annualMerchant/cityAndProperty',
        // eslint-disable-next-line
        __JAVA__DOMAIN__,
        true
      )
    )
  },
  getMaterialList: body => {
    return http(
      getRequestUrl(
        '/hms/hljActivity/appApi/annualMerchantTour/merchantMaterialsList',
        // eslint-disable-next-line
        __JAVA__DOMAIN__,
        true
      ),
      {
        body
      }
    )
  },
  getList: body => {
    return http(
      getRequestUrl(
        '/hms/hljActivity/appApi/annualMerchantTour/merchantLogoList',
        // eslint-disable-next-line
        __JAVA__DOMAIN__,
        true
      ),
      {
        body
      }
    )
  },
  getLocation: () => {
    return http(
      getRequestUrl(
        '/hps/home/user/index/ipAddress',
        // eslint-disable-next-line
        __NEW__PHP_DOMAIN__
      )
    )
  }
}
